module.exports = __webpack_public_path__ + "static/media/rad2Grey.208a45e6.svg";